import { render } from "./dialogVerInfo.vue?vue&type=template&id=2f129ae5&scoped=true"
import script from "./dialogVerInfo.vue?vue&type=script&lang=js"
export * from "./dialogVerInfo.vue?vue&type=script&lang=js"

import "./dialogVerInfo.vue?vue&type=style&index=0&id=2f129ae5&lang=scss&scoped=true"

import exportComponent from "E:\\06film\\web\\film-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f129ae5"]])

export default __exports__